export const CHANGE_ORGANIZATION = "CHANGE_ORGANIZATION"